export class LakersBackendApiRequestTimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LakersBackendApiRequestTimeoutError";
  }
}
